module.exports = __webpack_public_path__ + "img/location-fill.3713183e.svg";